module.exports = __webpack_public_path__ + "static/media/fish.6f44c1d1.svg";